import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { FreezeDriedRecipeDetail } from 'features/Recipes/FreezeDriedRecipeDetail'
import { FreezeDriedProteins } from 'models/Pet'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Beef Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbeef-half-freeze-dried-bowl.6754b917.webp&w=3840&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbeef-close-up.7e642f0d.webp&w=3840&q=75',
    ],
    description:
      'Packed with high-quality protein for muscle health and essential nutrients for digestion and a healthy coat.',
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Beef',
      },
      {
        '@type': 'PropertyValue',
        name: 'Beef Quality',
        value: 'Made with Grass-Fed Beef',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '13.21',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '22.02',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '13.21',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isRelatedTo: {
      '@type': 'Product',
      name: 'Beef Recipe',
      url: 'https://wefeedraw.com/recipes/beef',
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/chicken',
      },
      {
        '@type': 'Product',
        name: 'Turkey Recipe',
        url: 'https://wefeedraw.com/recipes/turkey',
      },
      {
        '@type': 'Product',
        name: 'Duck Recipe',
        url: 'https://wefeedraw.com/recipes/duck',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:freeze-dried.BEEF.meta.title')}</title>
        <meta name="title" content={t('recipes:freeze-dried.BEEF.meta.title')} />
        <meta name="description" content={t('recipes:freeze-dried.BEEF.meta.description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/freeze-dried-raw-beef" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>
      <main>
        <FreezeDriedRecipeDetail protein={FreezeDriedProteins.BEEF} />
      </main>
    </div>
  )
}
